import { withErrorLogger } from '@move-frontend/auth';
import { cognitoClient } from '../../../../shared/api/cognito';
import { logError } from '../../../../shared/error/logError';
import { IResetPasswordData } from '../models/IResetPasswordData';
import { ResetPasswordResult } from '../models/ResetPasswordResult';

async function performResetPassword({
	username,
	code,
	newPassword,
}: IResetPasswordData): Promise<ResetPasswordResult> {
	await cognitoClient.resetPassword(username, code, newPassword);
}

export const resetPassword = withErrorLogger(performResetPassword, {
	customLogError: logError,
});
